import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EggAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"egg_alt"}/>
}
